import { isPlayCondition } from "model/Match/PlayCondition";
import { MatchmakingFormat } from "model/Match/Set/Matchmaking/MatchmakingFormat";
import { mapPointsDistribution } from "../FsPointsDistribution";
import { mapSetFormatBase } from "../FsSetFormat";
import { FsMatchmakingFormat } from "db/model/match/Set/Matchmaking/FsMatchmakingFormat";
import { getDefaultPointsDistribution } from "model/Match/Set/PointsDistribution";

export const mapMatchmakingFormat = (
  fsModel: FsMatchmakingFormat
): MatchmakingFormat | undefined => {
  const base = mapSetFormatBase(fsModel);

  if (!base || !fsModel.numTracks || !isPlayCondition(fsModel.playCondition)) {
    return undefined;
  }

  // todo - default not assume 2 teams
  const points = !!fsModel.points
    ? mapPointsDistribution(fsModel.points)
    : getDefaultPointsDistribution(base.driversPerTeam * 2);
  if (!points) {
    return undefined;
  }

  return {
    ...base,
    numTracks: fsModel.numTracks,
    playCondition: fsModel.playCondition,
    points,
  };
};
